import React from "react";
import "./footer.scss";
const Footer = () => {
  return(
    <footer className="main-footer text-center fw-semibold bg-white w-100 main-gray">Copyright © {new Date().getFullYear()} Thrive Black Car. All Rights Reserved.</footer>
  )
}

export default Footer;